import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import DfbButton from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_button'

const MMultipleCtaButtons = ({ data }) => {
  const { headline, buttons } = data

  return (
    <Section data={data} defaultPadding="large">
      <div className="u-Wrapper">
        <div className="u-Container">
          <div className="u-Content">
            {headline && (
              <DfbHeadline headline={headline} headline_level="h2" add_class="c-Headline u-Theme-dark dfb-Headline--h2 dfb-Headline" />
            )}
            {buttons && (
              <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                {buttons.map((button) => (
                  <>
                    {button.layout === 'apple' || button.layout === 'google' ? (
                      <a href={button.link} target="_blank" rel="noopener noreferrer">
                        <img
                          height="60px"
                          style={{ padding: button.layout === 'apple' ? '6px 0' : undefined }}
                          src={button.layout === 'apple' ? '/images/apple_app_store.svg' : '/images/google_play.png'}
                          alt={button.layout === 'apple' ? 'Apple App Store' : button.layout === 'google' ? 'Google Play Store' : ''}
                        />
                      </a>
                    ) : (
                      <DfbButton text={button.link_text} link={button.link_obj.url} tagName="a" />
                    )}
                  </>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MMultipleCtaButtons
